import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { InLineLabel } from "../../components/Label";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { TableRow } from "../../components/table-components/TableRow";
import { PromotionCodeScope } from "../../model/PromotionCodeScope";
import { PromotionCodeListItem } from "../../service/api-response/PromotionCodesSuccessResponse";
import moment from "moment";

interface PromotionCodeListRowProps {
  href: string;
  promotionCode: PromotionCodeListItem;
  translation: any;
}

export const PromotionCodeListRow = ({
  href,
  promotionCode,
  translation,
}: PromotionCodeListRowProps) => {
  return (
    <TableRow>
      <TableCellLink href={href}>
        {promotionCode.scope === PromotionCodeScope.Subscription && (
          <InLineLabel backgroundColor={colors.ctaLight} color={colors.ctaMain}>
            Subscription
          </InLineLabel>
        )}
        {promotionCode.scope === PromotionCodeScope.Redeem && (
          <InLineLabel
            backgroundColor={colors.ctaInactive}
            color={colors.textPrimary}
          >
            Redeem
          </InLineLabel>
        )}
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {promotionCode.code}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {promotionCode.userFullName
            ? promotionCode.userFullName
            : promotionCode.userId}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {translation("promotion_code.list.row.valid_to", {
            date: moment(promotionCode.validFrom),
          })}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {translation("promotion_code.list.row.valid_to", {
            date: moment(promotionCode.validTo),
          })}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};
